import React, { useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import api, { extractError } from "@/lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
  const { token } = useParams();
  const nav = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) return toast.error("پاس ورڈ ملتے نہیں");
    if (pw.length < 6) return toast.error("کم از کم ٦ حروف");
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password: pw });
      toast.success("پاس ورڈ ری سیٹ ہو گیا، اب لاگ اِن کریں");
      nav("/login");
    } catch (err) {
      toast.error(extractError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-md mx-auto py-10" data-testid="reset-password-page">
      <Card className="p-6 sm:p-8 space-y-5">
        <h1 className="urdu-naskh text-3xl font-semibold text-primary text-center">نیا پاس ورڈ سیٹ کریں</h1>
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-1.5">
            <Label className="urdu-naskh">نیا پاس ورڈ</Label>
            <Input type="password" required minLength={6} value={pw} onChange={(e) => setPw(e.target.value)} dir="ltr" data-testid="reset-pw" />
          </div>
          <div className="space-y-1.5">
            <Label className="urdu-naskh">پاس ورڈ دوبارہ لکھیں</Label>
            <Input type="password" required minLength={6} value={pw2} onChange={(e) => setPw2(e.target.value)} dir="ltr" data-testid="reset-pw2" />
          </div>
          <Button type="submit" disabled={busy} className="w-full bg-primary" data-testid="reset-submit">
            {busy ? "محفوظ ہو رہا ہے…" : "پاس ورڈ محفوظ کریں"}
          </Button>
          <div className="text-center text-sm">
            <Link to="/login" className="text-primary underline">منسوخ</Link>
          </div>
        </form>
      </Card>
    </div>
  );
}
